import { newToast, useAppDispatch } from 'store'

interface ToastFunction {
  (message: string): void
}

export function useToast(): ToastFunction {
  const dispatch = useAppDispatch()
  let toast: ToastFunction = (message) => {
    dispatch(newToast(message))
  }
  return toast
}
